// Treść i wersje zgód — jedno źródło dla rejestracji, okna nowego regulaminu i profilu.
// Zmiana treści = nowa wersja (zapisywana przy koncie i w agreement_events).

// Regulamin i Polityka prywatności: data wejścia w życie obowiązującej wersji.
const TERMS_VERSION = '2025-09-01'
// Zgody marketingowe: wersja treści.
const MARKETING_VERSION = '2025-09-01'

const AGREEMENT_TEXTS = {
    terms: 'Oświadczam, że zapoznałem się i akceptuję treść Regulaminu i Polityki Prywatności',
    email_marketing: 'Zgadzam się na otrzymywanie drogą elektroniczną na wskazany przeze mnie adres e-mail informacji handlowych dotyczących produktów i usług SAMOCHODY.PL Sp. z o.o.  z siedzibą w Zielonej Górze przesyłanych przez SAMOCHODY.PL, zgodnie z obowiązującymi przepisami o ochronie danych osobowych, w celach marketingowych',
    other_marketing: 'Zgadzam się na otrzymywanie drogą elektroniczną na wskazany przeze mnie adres e-mail informacji handlowych dotyczących produktów i usług SAMOCHODY.PL Sp. z o.o. z siedzibą w Zielonej Górze oraz podmiotów trzecich współpracujących z SAMOCHODY.PL, przesyłanych zarówno przez SAMOCHODY.PL, jak i przez te podmioty trzecie, zgodnie z obowiązującymi przepisami o ochronie danych osobowych, w celach marketingowych',
}

export { AGREEMENT_TEXTS, MARKETING_VERSION, TERMS_VERSION }
